/* Mystery coverage guard.
   Rendered only on products carrying custom.mystery_unavailable (the mystery
   products). `blocked` is the list of variant ids whose size has no colorway
   in the merchant's pool. Selling one would strand the order On Hold, so:
   - add-to-cart disables while a blocked variant is selected
   - submit is intercepted as the hard stop (covers sticky ATC + quick add)
   - size pills re-gray after client-side variant swaps

   Only buttons this guard disabled get re-enabled (marker class), so it never
   fights the theme's own sold-out disabling. */
(function () {
  'use strict';
  var el = document.getElementById('mystery-blocked-data');
  if (!el) return;
  var blocked;
  try { blocked = JSON.parse(el.textContent).map(String); } catch (e) { return; }
  if (!blocked.length) return;

  function cartForms() {
    return document.querySelectorAll('form[action*="/cart/add"]');
  }
  function selectedId(form) {
    var input = form.querySelector('[name="id"]');
    return input ? String(input.value) : null;
  }

  function apply() {
    cartForms().forEach(function (form) {
      var bad = blocked.indexOf(selectedId(form)) > -1;
      form.querySelectorAll('button[type="submit"], [name="add"]').forEach(function (btn) {
        if (bad) {
          btn.setAttribute('disabled', 'disabled');
          btn.classList.add('mystery-blocked-btn');
        } else if (btn.classList.contains('mystery-blocked-btn')) {
          btn.removeAttribute('disabled');
          btn.classList.remove('mystery-blocked-btn');
        }
      });
    });
    document.querySelectorAll('[data-variant-id]').forEach(function (opt) {
      if (blocked.indexOf(String(opt.getAttribute('data-variant-id'))) > -1) {
        opt.classList.add('option-unavailable');
      }
    });
  }

  // The theme updates [name="id"] a tick after the radio change lands.
  document.addEventListener('change', function () { setTimeout(apply, 50); }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (blocked.indexOf(selectedId(form)) > -1) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  apply();
  setTimeout(apply, 600);   // after deferred theme JS settles
  setTimeout(apply, 2000);  // after late-injected sticky ATC
})();
